export default __webpack_public_path__ + "static/media/s4_title-winter.d7f510aa.png";